import { render, staticRenderFns } from "./AppStoreLightVersionModal.vue?vue&type=template&id=4caf1116&"
import script from "./AppStoreLightVersionModal.vue?vue&type=script&lang=js&"
export * from "./AppStoreLightVersionModal.vue?vue&type=script&lang=js&"
import style0 from "./AppStoreLightVersionModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports